import React, {Component} from 'react'
import AdminFilterForm from "../Filters/TableFilters/AdminFilterForm";
import AdminTableRow from "./AdminTableRow";
import Loader from "../Simple/Loader";
import ApplicationModal from "../Application/ApplicationModal";

export default class AdminTable extends Component {
    state = {
        sort: 'desc',
        order: null,
        openDetailIds: [],
        isEditModalVisible: false,
        modalItemId: null
    }

    toggleEditModal = (id) => this.setState({isEditModalVisible: !this.state.isEditModalVisible, modalItemId: id})

    changeOrder = newOrder => {
        let newSort = this.state.sort;
        if ((this.state.order && newOrder && this.state.order[0] === newOrder[0]) || this.state.order === null) {
            if (newSort === 'asc') {
                newSort = 'desc'
            } else {
                newSort = 'asc'
            }
        }
        this.setState({order: newOrder, sort: newSort})
        const newOrderSort = {order: newOrder + '|' + newSort}
        this.props.onAddFilter(newOrderSort)
    }

    showDetails = (id) => {
        const openDetailIds = this.state.openDetailIds;
        const index = openDetailIds.indexOf(id)
        if (index >= 0) {
            openDetailIds.splice(index, 1);
        } else {
            openDetailIds.push(id);
        }
        this.setState({
            openDetailIds: openDetailIds
        });
    }
    clearShowDetailIds = () => {

        this.setState({
            openDetailIds: []
        });
    }

    render() {
        const {
            isLoading,
            items,
            showChilds,
            showChildHeader,
            columns,
            childColumns,
            onAddFilter,
            onRemoveFilter,
            filters,
            savedFilters,
            onSetSavedFilters,
            onSaveFilters,
            onRemoveSavedFilters,
            availableColumns,
            viewType
        } = this.props

        const {isEditModalVisible, modalItemId} = this.state

        return (
            <>
                <div className="status-description-wrapper">
                    <span className="status-description"><span className="status-icon status-10"
                                                               title="Allekirjoituksessa"></span> Vahvistettu</span>
                    <span className="status-description"><span className="status-icon status-8"
                                                               title="Allekirjoituksessa"></span> Tarjous hyväksytty</span>
                    <span className="status-description"><span className="status-icon status-7"
                                                               title="Allekirjoituksessa"></span> Tarjous tehty</span>
                    <span className="status-description"><span className="status-icon status-5"
                                                               title="Allekirjoituksessa"></span> Odottaa tarjousta</span>
                    <span className="status-description"><span className="status-icon status-1"
                                                               title="Allekirjoituksessa"></span> Hylätty</span>
                </div>
                {!isLoading && <div className='table-responsive'>
                    <table className='table admin-table table-hover'>
                        <thead>
                        <tr>
                            {false && <th>#</th>}
                            {columns.map((value, index) => (
                                <th scope="col"
                                    onClick={() => this.changeOrder(value.alias)}
                                    key={index}>
                                    {!value.hideColumnLabel && value.label}
                                    {(filters.order === value.alias + '|asc') && <i className="fas fa-caret-up"></i>}
                                    {(filters.order === value.alias + '|desc') && <i className="fas fa-caret-down"></i>}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {items && items.map((value, key) => (
                            <AdminTableRow
                                item={value}
                                key={key}
                                index={key}
                                showChilds={(showChilds || this.state.openDetailIds.indexOf(value.id) >= 0)}
                                showChildHeader={showChildHeader}
                                columns={columns}
                                childColumns={childColumns}
                                showDetails={this.showDetails}
                                viewType={viewType}
                                onClick={() => this.toggleEditModal(value.id)}
                            />
                        ))}
                        </tbody>
                    </table>
                </div>}
                {isEditModalVisible && <ApplicationModal toggle={this.toggleEditModal} id={modalItemId}></ApplicationModal>}
                {isLoading && (
                    <div className="loader-wrapper my-5">
                        <Loader/>
                    </div>
                )}
            </>
        )
    }
}
